import { Component, OnDestroy } from '@angular/core';

import { NoConnectionModalService } from '@core/services/no-connection-modal/no-connection-modal.service';

@Component({
  selector: 'app-no-connection-modal',
  templateUrl: './no-connection-modal.component.html',
  standalone: false,
})
export class NoConnectionModalComponent implements OnDestroy {
  static handle = 'no-connection-modal';
  retryInProgress$ = this.noConnectionModalService.getRetryInProgress$();
  keyboardOffset = 0; // For keyboard-aware positioning

  constructor(private readonly noConnectionModalService: NoConnectionModalService) {}

  ngOnDestroy(): void {
    this.noConnectionModalService.setRetryInProgress(false);
  }

  reload(): void {
    window.location.reload();
  }
}
